export const LEFT_KEY = 37;
export const RIGHT_KEY = 39;
